import { MapContainer, TileLayer, Marker, Popup, ZoomControl } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { useNavigate } from "react-router-dom";
import { useMemo } from "react";

const DEPT_CENTER = [48.42, 1.35];

function pinIcon(count, kindColor) {
  const inner = count > 1
    ? `<span style="font-weight:800;font-size:13px;font-family:Outfit,sans-serif">${count}</span>`
    : `<svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18z"/><path d="M12 8v8M8 12h8"/></svg>`;
  const size = count > 1 ? 34 : 28;
  const html = `<div style="position:relative"><div style="width:${size}px;height:${size}px;border-radius:50%;background:${kindColor};box-shadow:0 4px 10px rgba(224,86,56,.4);display:flex;align-items:center;justify-content:center;color:#fff;border:3px solid #fff">${inner}</div><div style="position:absolute;left:50%;top:${size}px;transform:translateX(-50%);width:0;height:0;border:6px solid transparent;border-top-color:${kindColor}"></div></div>`;
  return L.divIcon({ html, className: "", iconSize: [size, size + 10], iconAnchor: [size / 2, size + 10] });
}

export default function NeighborMap({ posts = [], center = null }) {
  const navigate = useNavigate();
  const initCenter = center ? [center.lat, center.lng] : DEPT_CENTER;
  const initZoom = center ? 11 : 9;
  const communes = useMemo(() => {
    const groups = {};
    (posts || []).filter((p) => typeof p.lat === "number" && typeof p.lng === "number").forEach((p) => {
      const key = (p.city || "—").trim().toLowerCase();
      if (!groups[key]) groups[key] = { key, city: p.city, lat: p.lat, lng: p.lng, items: [] };
      groups[key].items.push(p);
    });
    return Object.values(groups);
  }, [posts]);

  return (
    <div className="relative rounded-2xl overflow-hidden border border-slate-200 shadow-sm bg-white" data-testid="voisin-map">
      <MapContainer key={center ? `${center.lat},${center.lng}` : "dept"} center={initCenter} zoom={initZoom} scrollWheelZoom={false} zoomControl={false} style={{ height: "480px", width: "100%" }}>
        <ZoomControl position="bottomright" />
        <TileLayer attribution='&copy; OpenStreetMap' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        {communes.map((c) => (
          <Marker key={c.key} position={[c.lat, c.lng]} icon={pinIcon(c.items.length, "#E05638")}>
            <Popup>
              <div style={{ fontFamily: "Outfit, sans-serif", minWidth: 200, maxWidth: 250 }}>
                <div style={{ fontWeight: 800, marginBottom: 6 }}>{c.city} · {c.items.length} annonce{c.items.length > 1 ? "s" : ""}</div>
                <div style={{ display: "flex", flexDirection: "column", gap: 4, maxHeight: 190, overflowY: "auto" }}>
                  {c.items.map((p) => (
                    <button key={p.id} onClick={() => navigate(`/entre-voisins/${p.id}`)}
                      style={{ textAlign: "left", padding: "6px 8px", borderRadius: 8, border: "none", background: "#f8fafc", cursor: "pointer", width: "100%" }}>
                      <span style={{ fontWeight: 600, fontSize: 13, color: "#0f172a" }}>{p.title}</span>
                      <span style={{ display: "block", fontSize: 11, color: p.kind === "offer" ? "#059669" : "#E05638", fontWeight: 600 }}>
                        {p.kind === "offer" ? "Je propose" : "Je cherche"} · {p.category} →
                      </span>
                    </button>
                  ))}
                </div>
              </div>
            </Popup>
          </Marker>
        ))}
      </MapContainer>
      <div className="absolute top-3 left-3 bg-white/95 backdrop-blur px-3 py-2 rounded-xl border border-slate-200 shadow-sm text-xs text-slate-600 z-[500]">
        <div className="font-bold text-slate-900">{posts.filter((p) => p.lat).length} annonce(s) localisée(s)</div>
        <div className="flex items-center gap-2 mt-1"><span className="inline-block w-3 h-3 rounded-full bg-[#E05638]"></span> Demandes & propositions par commune</div>
      </div>
    </div>
  );
}
